<template>

  <section class="dp-layout">
    <!-- 
    <section class="dp-left" :style="{
      display: this.$store.state.HasChildrenDepartment ? 'block' : 'none',
    }"> -->
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>

    <section class="dp-right">
      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <!--列表-->
      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow" ref="table"
        class="custom-tbl" height="100%" style="width: 100%">
        <el-table-column type="selection" width="50"> </el-table-column>
        <el-table-column prop="KqTerminalId" label="终端标识" width="">
        </el-table-column>
        <el-table-column prop="TerminalName" label="终端名称" width="">
        </el-table-column>
        <el-table-column prop="DepartmentName" label="所属部门" width="">
        </el-table-column>
        <el-table-column prop="InstallAddress" label="安装位置" width="">
        </el-table-column>

        <el-table-column prop="IsOnLine" label="是否在线" width>
          <template slot-scope="scope">
            <el-tag :type="scope.row.IsOnLine == 1 ? 'success' : 'danger'" disable-transitions>{{ scope.row.IsOnLine ==
              1 ?
              "在线" :
              "离线" }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="IsPush" label="是否推送消息" width="130">
          <template slot-scope="scope">
            <el-tag :type="scope.row.IsPush ? 'success' : 'danger'">
              {{ scope.row.IsPush ? '推送' : '不推送' }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="TerminalDesc" label="备注" width="">
        </el-table-column>
        <el-table-column prop="TouchTypeDirection" label="终端方向" :formatter="formatTouchTypeDirection" width="">
        </el-table-column>
        <el-table-column prop="CreateTime" label="添加时间">
        </el-table-column>
      </el-table>
      </div>

      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="10" :total="total"
          style="float: right">
        </el-pagination>
      </el-col>
      <!--编辑界面-->
      <el-dialog title="编辑终端信息" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false">
        <el-form :model="editForm" label-width="110px" :rules="editFormRules" ref="editForm">

          <el-form-item label="终端标识" prop="KqTerminalId">
            <el-input v-model="editForm.KqTerminalId" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="终端名称" prop="TerminalName">
            <el-input v-model="editForm.TerminalName" auto-complete="off"></el-input>
          </el-form-item>

          <!-- 去除所属机构选择，直接关联页面统一选中的学校 ID -->

          <el-form-item label="安装位置" prop="InstallAddress">
            <el-input v-model="editForm.InstallAddress" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="联动录像" prop="InstallPosition">
            <el-select v-model="editForm.InstallPosition" placeholder="请选择仅联动录像摄像头" clearable style="width: 100%">
              <el-option
                v-for="item in cameraList"
                :key="item.DeviceId"
                :label="formatGateVideoCameraLabel(item)"
                :value="item.DeviceId"
              >
              </el-option>
            </el-select>
            <div class="bind-help">仅显示用途为「仅联动录像」的摄像头，请先在摄像头管理中配置。</div>
          </el-form-item>

          <el-form-item label="终端方向" prop="TouchTypeDirection">
            <el-select v-model="editForm.TouchTypeDirection" placeholder="请选择终端方向">
              <el-option label="出入" value="inout"></el-option>
              <el-option label="离开" value="out"></el-option>
              <el-option label="进入" value="in"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="是否推送消息" prop="IsPush">
            <el-switch v-model="editForm.IsPush" :active-value="true" :inactive-value="false" active-text="推送"
              inactive-text="不推送"></el-switch>
          </el-form-item>

          <el-form-item label="设备说明">
            <el-input type="textarea" v-model="editForm.TerminalDesc"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
        </div>
      </el-dialog>

      <!--新增界面-->
      <el-dialog title="新增终端信息" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false">
        <el-form :model="addForm" label-width="110px" :rules="addFormRules" ref="addForm" class="demo-form-inline">

          <el-form-item label="终端标识" prop="KqTerminalId">
            <el-input v-model="addForm.KqTerminalId" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="终端名称" prop="TerminalName">
            <el-input v-model="addForm.TerminalName" auto-complete="off"></el-input>
          </el-form-item>

          <!-- 去除所属机构选择，直接关联页面统一选中的学校 ID -->

          <el-form-item label="安装位置" prop="InstallAddress">
            <el-input v-model="addForm.InstallAddress" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="联动录像" prop="InstallPosition">
            <el-select v-model="addForm.InstallPosition" placeholder="请选择仅联动录像摄像头" clearable style="width: 100%">
              <el-option
                v-for="item in cameraList"
                :key="item.DeviceId"
                :label="formatGateVideoCameraLabel(item)"
                :value="item.DeviceId"
              >
              </el-option>
            </el-select>
            <div class="bind-help">仅显示用途为「仅联动录像」的摄像头，请先在摄像头管理中配置。</div>
          </el-form-item>

          <el-form-item label="终端方向" prop="TouchTypeDirection">
            <el-select v-model="addForm.TouchTypeDirection" placeholder="请选择终端方向">
              <el-option label="出入" value="inout"></el-option>
              <el-option label="离开" value="out"></el-option>
              <el-option label="进入" value="in"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="是否推送消息" prop="IsPush">
            <el-switch v-model="addForm.IsPush" :active-value="true" :inactive-value="false" active-text="推送"
              inactive-text="不推送"></el-switch>
          </el-form-item>

          <el-form-item label="设备说明">
            <el-input type="textarea" v-model="addForm.TerminalDesc"></el-input>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>

    </section>

  </section>

</template>

<script>
import axios from "axios";
import util from "../../../util/date";
import { testapi } from '../../api/modules/auth';
import { getKqtDeviceTerminalListPage, removeKqtDeviceTerminal, editKqtDeviceTerminal, addKqtDeviceTerminal } from '../../api/modules/attendance';
import { getTeachingDepartmentTree } from '../../api/modules/department';
import { BaseApiUrl } from '../../api/base';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import es from "@/lang/es";

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      filters: {
      },
      BaseApiUrl: BaseApiUrl, //网络前缀
      searchList: [
        {
          label: '终端名称',
          key: 'name',
        },
        {
          label: '序列号',
          key: 'kqTerminalId',
          placeholder: '终端标识/序列号'
        },
        {
          label: '状态',
          key: 'isOnLine',
          type: 'select',
          width: '110px',
          options: [
            { label: '全部', value: '' },
            { label: '在线', value: '1' },
            { label: '离线', value: '0' }
          ]
        },
      ],
      users: [],
      roles: [],
      options: [],
      total: 0,
      buttonList: [],
      currentRow: null,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      liveTypeList: [],
      liveTypeId: "",
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        KqTerminalId: [
          { required: true, message: "请输入终端标识", trigger: "blur" },
        ],
        TerminalName: [{ required: true, message: "请输入终端名称", trigger: "blur" }],
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        KqTerminalId: "",
        TerminalName: "",
        TouchTypeDirection: "",
        TerminalDesc: "",
        Dids: [],
        DepartmentId: 0,
        TerminalTypeId: "0",
        InstallAddress: "",
        InstallPosition: "",
        IsPush: true
      },
      isResouceShow: 0,
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        KqTerminalId: [
          { required: true, message: "请输入终端标识", trigger: "blur" },
        ],
        TerminalName: [{ required: true, message: "请输入终端名称", trigger: "blur" }],
      },
      //新增界面数据
      addForm: {
        KqTerminalId: "",
        TerminalName: "",
        TouchTypeDirection: "",
        TerminalDesc: "",
        Dids: [],
        DepartmentId: 0,
        TerminalTypeId: "0",
        InstallAddress: "",
        InstallPosition: "",
        IsPush: true
      },
      DepartmentId: 0,
      currentUserId: '',
      imageUrl: '',
      imageLoadding: false,
      cameraList: []
    };
  },
  // 移除对表单 Dids 的侦听，改由在打开新增/编辑弹窗时直接根据 DepartmentId 触发 loadCameraList
  methods: {

    formatTouchTypeDirection: function (row, column) {

      if (row.TouchTypeDirection == "inout") {
        return "出入";
      } else if (row.TouchTypeDirection == "in") {
        return "进入";
      } else if (row.TouchTypeDirection == "out") {
        return "离开";
      } else {
        return "";
      }
    },

    beforeAvatarUpload(file) {
      // 这里可以过滤不要的文件
      this.imageLoadding = true
      return true
    },

    //头像上传成功
    handleAvatarSuccess(res, file) {
      this.imageLoadding = false
      console.log(res)
      this.imageUrl = res.response
    },

    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value
      this.handleQuery();
      let para = {
        id: this.DepartmentId,
      };
    },

    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },

    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },

    //获取用户列表
    handleQuery() {
      let para = {
        page: this.page,
        departmentId: this.DepartmentId,
        ...this.filters,
        type: "0"
      }
      this.listLoading = true;

      testapi();
      //NProgress.start();
      getKqtDeviceTerminalListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
        //NProgress.done();
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      const isTbDevice = row.TerminalTypeId === "2" || row.TerminalTypeId === "4" || row.TerminalTypeId === "6" || row.TerminalTypeId === "7";
      const confirmMsg = isTbDevice
        ? "确认删除该记录吗？天波未提供删除设备接口，仅删除本地记录，天波侧设备不会同步删除。"
        : "确认删除该记录吗?";
      this.$confirm(confirmMsg, "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.Id };
          removeKqtDeviceTerminal(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: res.data.msg || "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.handleQuery();
          });
        })
        .catch(() => { });
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
      // 优先使用当前终端绑定的所属学校ID，若无则使用当前页面统一选中的 ID 兜底
      const schoolId = this.editForm.DepartmentId || this.DepartmentId;
      this.editForm.DepartmentId = schoolId;
      this.loadCameraList(schoolId);
    },
    //显示新增界面
    handleAdd() {
      // 限制：必须先在左侧选择具体的学校机构才能进行考勤终端的新增
      if (!this.DepartmentId || this.DepartmentId === '0' || this.DepartmentId === 0) {
        this.$message.warning("请先在左侧选择具体的学校机构！");
        return;
      }
      this.addFormVisible = true;
      this.addForm = {
        KqTerminalId: "",
        TerminalName: "",
        TouchTypeDirection: "",
        TerminalDesc: "",
        Dids: [],
        DepartmentId: this.DepartmentId, // 直接使用当前页面统一选中的学校ID
        TerminalTypeId: "0",
        InstallAddress: "",
        InstallPosition: "",
        IsPush: true
      };
      this.loadCameraList(this.DepartmentId);
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);

            editKqtDeviceTerminal(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.options = [];
                this.editFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.addLoading = false;
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);

            addKqtDeviceTerminal(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }

              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.options = [];
                this.addFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.addLoading = false;
              }
            });
          });
        }
      });
    },

    loadCameraList(schoolId) {
      if (!schoolId) {
        this.cameraList = [];
        return;
      }
      // 只拉可供考勤终端联动录像的摄像头。最后更新：2026-10-26
      axios.get(`${BaseApiUrl}/api/KqtCameraDevice/GetListBySchool`, {
        params: { schoolId, usage: "GateVideo" }
      }).then((res) => {
        if (res.data && res.data.success) {
          this.cameraList = res.data.response || [];
        } else {
          this.cameraList = [];
        }
      }).catch(() => {
        this.cameraList = [];
      });
    },

    /** 联动录像下拉展示名 */
    formatGateVideoCameraLabel(item) {
      if (!item) return "";
      return `${item.DeviceName} (${item.DeviceId})`;
    }

  },
  mounted() {

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.bind-help {
  margin-top: 4px;
  color: #7c8aa0;
  font-size: 12px;
  line-height: 1.45;
}

.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: var(--btn-primary, #2563eb);
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 106.8px;
  height: 106.8px;
  line-height: 106.8px;
  text-align: center;
}

.avatar {
  width: 106.8px;
  height: 106.8px;
  display: block;
}

.avatar-uploader-tip {
  position: absolute;
  width: 100%;
  height: 1vw;
  bottom: 20px;
  color: gray;
  z-index: 99;
}
</style>
